import React, { useEffect, useState } from 'react';
import Segmented from '../../../components/segmented/Segmented.jsx';
import '../../../App.scss';
import WalletCard from './components/WalletCard.jsx';
import { DatePicker, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from "../../../store/Slices/userSlice.js";
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import ConfirmationModal from '../../../components/modals/ConfirmationModal.jsx';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import { GetDashboardApi, GetEarningApi, GetTradeZoneApi, SendIBRequestApi, GetIBRequestStatusApi } from '../../../api/request/dashboard.js';
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
import toast from 'react-hot-toast';
import CreateLiveAccount from './components/CreateLiveAccount.jsx';
import moment from 'moment';
import ReactPlayer from 'react-player'
import AccountTabs from './components/AccountTabs.jsx';
import RecentTable from './components/RecentTable.jsx';
import Deposit from '../../../assets/user/Deposit.jsx';
import Withdraw from '../../../assets/user/Withdraw.jsx';
import Overview from './components/Overview.jsx';
import OpenTrades from './components/OpenTrades.jsx';
import { useNavigate } from 'react-router-dom';
import { handleApiError } from '../../../utils/handleApiError.js';

const Dashboard2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state.user);
  const [isLoading, setIsLoading] = useState(true);
  const [isMyEarningLoading, setIsMyEarningLoading] = useState(false);
  const [myEarning, setMyEarning] = useState([]);
  const [myEarningRange, setMyEarningRange] = useState({ from: '', to: '' });
  const [isTradeZoneLoading, setIsTradeZoneLoading] = useState(false);
  const [myTradeZone, setMyTradeZone] = useState([]);
  const [myTradeZoneRange, setMyTradeZoneRange] = useState({ from: '', to: '' });
  const [accountLogins, setAccountLogins] = useState([]);
  const [activeAccountLogins, setActiveAccountLogins] = useState('');
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isIbReqLoading, setIsIbReqLoading] = useState(false);
  const [isIbPendingModalOpen, setIsIbPendingModalOpen] = useState(false);
  const [isIbApprovedModalOpen, setIsIbApprovedModalOpen] = useState(false);
  const [isIbReqStatusLoading, setIsIbReqStatusLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [tutorials, setTutorials] = useState();
  const [tutorialsdetails, setTutorialsdetails] = useState({});
  const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
  const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();
  const secondary = (getComputedStyle(document.documentElement).getPropertyValue('--theme2'))?.trim();

  const filterAccounts = (data) => {
    const accountLogins = data?.filter((account) => account?.isLive)?.map((account) => account?.accountNo);
    setAccountLogins(accountLogins);
    setActiveAccountLogins(accountLogins?.[0]);
  };

  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetDashboardApi();
      if (data?.success) {
        setData(data?.data);
        filterAccounts(data?.data?.mT5AccountList);
        setIsLoading(false);
      }
    } catch (error) { }
  }

  const getAllTutorials = async () => {
    try {
      let params = {
        tutorialType: "Dashboard"
      }
      const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setTutorials(data?.data);
      }
    } catch (error) {
    }
  }

  const getMyEarnings = async (loginId) => {
    if (!loginId) {
      return;
    }
    try {
      setIsMyEarningLoading(true);
      let params = {
        FromDate: myEarningRange?.from,
        ToDate: myEarningRange?.to
      }
      const { data } = await GetEarningApi(loginId, new URLSearchParams(params).toString());
      if (data?.success) {
        let lossData = [];
        let profitData = [];
        let dateData = [];
        data?.data?.map((item) => {
          lossData?.push(item?.totalLossTop);
          profitData?.push(item?.totalProfitTop);
          dateData?.push(moment(item?.dealDate).format('MMM DD'));
        })
        setMyEarning({ categories: dateData, series: [{ name: 'Total Loss', data: lossData, prefix: '$', postfix: '' }, { name: 'Total Profit', data: profitData, prefix: '$', postfix: '' }] });
        setIsMyEarningLoading(false);
      }
    } catch (error) { }
  }

  const getMyTradeZone = async (loginId) => {
    if (!loginId) {
      return;
    }
    try {
      setIsTradeZoneLoading(true);
      let params = {
        FromDate: myTradeZoneRange.from,
        ToDate: myTradeZoneRange.to
      }
      const { data } = await GetTradeZoneApi(loginId, new URLSearchParams(params).toString());
      if (data?.success) {
        let lossData = [];
        let profitData = [];
        let symbolsData = [];
        let dateData = [];
        data?.data?.map((item) => {
          lossData?.push(item?.totalLoss);
          profitData?.push(item?.totalProfit);
          symbolsData?.push(item?.symbol);
          dateData?.push(`${moment(item?.dealDate).format('MMM DD')}`);
        })
        setMyTradeZone({ categories: dateData, series: [{ name: 'Total Loss', data: lossData, prefix: '$', postfix: '' }, { name: 'Total Profit', data: profitData, prefix: '$', postfix: '' }], symbols: symbolsData });
        setIsTradeZoneLoading(false);
      }
    } catch (error) { }
  }

  useEffect(() => {
    getDashboard();
    getAllTutorials()
  }, []);

  useEffect(() => {
    getMyEarnings(activeAccountLogins);
    getMyTradeZone(activeAccountLogins);
  }, [activeAccountLogins]);

  useEffect(() => {
    getMyEarnings(activeAccountLogins);
  }, [myEarningRange]);

  useEffect(() => {
    getMyTradeZone(activeAccountLogins);
  }, [myTradeZoneRange]);


  const sendIbRequest = async () => {
    try {
      setIsIbReqLoading(true);
      let params = {
        userId: userDetails?._id,
        isIBUser: true,
      }
      const { data } = await SendIBRequestApi(params);
      if (data?.success) {
        dispatch(setUserDetails({ ...userDetails, ibRequestStatus: 'Pending' }));
        toast.success(data?.message);
        setIsIbReqLoading(false);
        setIsModalOpen(false);
      }
      setIsIbReqLoading(false);
      setIsModalOpen(false);
    } catch (error) {
      handleApiError(error);
      setIsIbReqLoading(false);
      setIsModalOpen(false);
    }
  }

  const checkRequestStatus = async () => {
    try {
      setIsIbReqStatusLoading(true);
      const { data } = await GetIBRequestStatusApi(userDetails?._id);
      if (data?.success) {
        if (data?.data?.ibRequestStatus === 'Pending') {
          setIsIbPendingModalOpen(true);
        }
        if (data?.data?.ibRequestStatus === 'Rejected') {
          // setIsIbPendingModalOpen(true);
          dispatch(setUserDetails({ ...userDetails, ibRequestStatus: 'Rejected' }));
        }
        if (data?.data?.ibRequestStatus === 'Approved') {
          setIsIbApprovedModalOpen(true);
          dispatch(setUserDetails({ ...userDetails, ibRequestStatus: 'Approved', referralCode: data?.data?.referralCode, roleName: "IBUser" }));
          setTimeout(() => {
            setIsIbApprovedModalOpen(false);
          }, 2000);
        }
      }
      setIsIbReqStatusLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsIbReqStatusLoading(false);
    }
  }

  const addTutorialsModalHandler = (Item) => {
    setIsOpenModaldetails(true);
    setTutorialsdetails(Item)
  }

  const renderIbRequestAction = () => {
    if (userDetails?.kycStatus !== 'Approved') {
      return null;
    }

    if (userDetails?.ibRequestStatus === 'Not Applied' || userDetails?.ibRequestStatus === 'Rejected') {
      return (
        <button className='bg-primary text-white font-medium px-4 py-2 rounded-lg themeHover duration-500' onClick={() => setIsModalOpen(true)}>Request to become a IB</button>
      );
    }

    if (userDetails?.ibRequestStatus === 'Pending') {
      return (
        <LoadableButton
          className='bg-primary text-white text-base font-semibold rounded-lg px-4 py-2 themeHover duration-500'
          disabled={isIbReqStatusLoading}
          lable='Check IB Status'
          isLoading={isIbReqStatusLoading}
          onClick={checkRequestStatus}
          loadingLable='Checking Status...'
        />
      );
    }

    return null;
  };


  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center flex-col mt-[20%]">
          <Spin size="large" />
          <p className="primary text-center mt-2">Loading...</p>
        </div>
      ) : (
        <div>
          {
            accountLogins?.length != 0 ? (
              <div>
                <div className='flex flex-wrap items-center justify-between sm:gap-5 gap-4'>
                  <div>
                    {accountLogins?.length > 0 && <Segmented options={accountLogins} value={activeAccountLogins} setValue={setActiveAccountLogins} />}
                  </div>
                  <div className='flex items-center gap-4'>
                    <div className='flex items-center whitespace-nowrap' onClick={() => setIsOpenModal(true)}>
                      <button className=' text-sm text-white font-bold pr-9 pl-5 py-2 themeHover duration-500 bg-primary from-teal-500 to-teal-600 rounded-full p-1 shadow-lg' >Video Tutorial</button>
                      <div className={`flex justify-center items-center ${secondary ? 'bg-secondary' : 'bg-primary'} w-[43px] h-[43px] rounded-[50%] ml-[-28px]`}>
                        <img src="/assets/icons/Group.svg" width={16} className='ml-[1px]' alt='icon' />
                      </div>
                    </div>
                    {renderIbRequestAction()}
                  </div>
                </div>

                <div className='mt-6'>
                  <div className="grid grid-cols-6 sm:gap-5 gap-4">
                    <div className="col-span-6 md:col-span-2 xl:col-span-1 order-1" onClick={() => navigate('/deposit')}>
                      <WalletCard />
                    </div>

                    <div className="col-span-6 xl:col-span-5 order-3 xl:order-2">
                      <Overview loginId={activeAccountLogins} />
                    </div>

                    <div className="col-span-6 xl:col-span-5 border-2 border-light rounded-[10px] p-5 order-3">
                      <div className='flex items-center justify-between'>
                        <h2 className="text-lg font-semibold">Open Trades</h2>
                        <a href={`/trades/${activeAccountLogins}`} className='text-sm text-blue-500'>View All</a>
                      </div>

                      <div className="mt-5">
                        <OpenTrades loginId={activeAccountLogins} />
                      </div>
                    </div>

                    <div className='grid max-sm:grid-cols-2 grid-flow-col xl:grid-flow-row col-span-6 md:col-span-4 xl:col-span-1 sm:gap-5 gap-4 order-2 xl:order-4'>
                      <div className="border-2 border-light rounded-[10px] p-5">
                        <div className="flex flex-col items-center justify-center gap-2 h-full cursor-pointer" onClick={() => navigate('/deposit')}>
                          <div className={`flex justify-center items-center w-[45px] h-[45px] rounded-lg bg-[#DDF6E8]`} >
                            <Deposit color="#28C76F" size={6} />
                          </div>
                          <div className='text-center'>
                            <p className=" text-xl">${data?.depositeAmount || 0}</p>
                            <p className='text-gray-500'>Deposit</p>
                          </div>
                        </div>
                      </div>

                      <div className="border-2 border-light rounded-[10px] p-5">
                        <div className="flex flex-col items-center justify-center gap-2 h-full cursor-pointer" onClick={() => navigate('/withdraw')}>
                          <div className={`flex justify-center items-center w-[45px] h-[45px] rounded-lg bg-[#FFE2E3]`}>
                            <Withdraw color="#FF4C51" size={6} />
                          </div>
                          <div className='text-center'>
                            <p className=" text-xl">${data?.withdrawAmount || 0}</p>
                            <p className='text-gray-500'>Withdraw</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-span-6 xl:col-span-3 order-5">
                      <RecentTable data={data} />
                    </div>

                    <div className="col-span-6 xl:col-span-3 order-6">
                      <AccountTabs data={data?.mT5AccountList} />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className='flex justify-end mb-4'>
                  {renderIbRequestAction()}
                </div>
                <CreateLiveAccount />
              </div>
            )
          }
        </div>
      )
      }

      {/* --- Kyc confirmation modal --- */}
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        type='success'
        message='Are you sure you want to send IB Request?'
        onConfirm={sendIbRequest}
        isLoading={isIbReqLoading}
        loadingLabel='Sending Request...'
      />

      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Tutorial' width={1000}>
        {tutorials && tutorials.length > 0 ? (<div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
          {tutorials?.map((item, index) => (
            <div
              key={index}
              className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
              onClick={() => addTutorialsModalHandler(item)}
            >
              <div className="relative pb-[56.25%] h-0">
                {item.youtubeUrl ? (
                  <ReactPlayer
                    url={item.youtubeUrl}
                    className="absolute top-0 left-0 w-full h-full"
                    width="100%"
                    height="100%"
                    controls
                  />
                ) : item.videoUrl ? (
                  <ReactPlayer
                    url={item.videoUrl}
                    className="absolute top-0 left-0 w-full h-full"
                    width="100%"
                    height="100%"
                    controls
                  />
                ) : (
                  <p>Video not available</p>
                )}
              </div>
              <div className="text-center p-4">
                <p className="text-lg font-semibold line-limit-1">{tutorials?.title}</p>
                <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorials?.description}</p>
              </div>
            </div>
          ))}
        </div>
        ) : (
          <div className='text-center'>
            <p className='text-lg font-semibold'>Video not available</p>
          </div>
        )}
      </ModalComponent>

      <ModalComponent isOpen={isOpenModaldetails} setIsOpen={setIsOpenModaldetails} title='Tutorial' width={800}>
        <div className="relative pb-[56.25%] h-0">

          {tutorialsdetails.youtubeUrl ? (
            <ReactPlayer
              url={tutorialsdetails.youtubeUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : tutorialsdetails.videoUrl ? (
            <ReactPlayer
              url={tutorialsdetails.videoUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : (
            <p>Video not available</p>
          )}
        </div>
        <div className="text-center p-4">
          <p className="text-lg font-semibold line-limit-1">{tutorialsdetails?.title}</p>
          <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorialsdetails?.description}</p>
        </div>
      </ModalComponent>

      {/* Ib request pending status */}
      <ModalComponent isOpen={isIbPendingModalOpen} setIsOpen={setIsIbPendingModalOpen} title='IB Request Status'>
        <div>
          <p className='font-bold text-[#2F2B3D] text-xl'>Your IB request is under proccess...</p>
          <p className="mt-4 text-lg">Please wait our admin team is working on your request.</p>
        </div>
      </ModalComponent>

      {/* Ib request approved status */}
      <ModalComponent isOpen={isIbApprovedModalOpen} setIsOpen={setIsIbApprovedModalOpen} title='IB Request Status'>
        <div>
          <p className='font-bold text-[#2F2B3D] text-xl'>Congratulations...</p>
          <p className="mt-4 text-lg">Your IB Request is approved.</p>
        </div>
      </ModalComponent>
    </div>
  )
}

export default Dashboard2;